import { restClient } from '@/Core'

export const DeleteExecutorAssignmentTask = async (uuid: string): Promise<void> => {
    await restClient.delete(`/services/executor-assignments/${uuid}`)
}
